// extracted by mini-css-extract-plugin
module.exports = {"item":"TrustedByCard_item__tkww6","footer":"TrustedByCard_footer__2qo_Q","logo":"TrustedByCard_logo___lVNP","textBlock":"TrustedByCard_textBlock__gqtKz"};